(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);throw new Error("Cannot find module '"+o+"'")}var f=n[o]={exports:{}};t[o][0].call(f.exports,function(e){var n=t[o][1][e];return s(n?n:e)},f,f.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bootstrapTOC = bootstrapTOC;
/*!
 * Bootstrap Table of Contents v1.0.1 (http://afeld.github.io/bootstrap-toc/)
 * Copyright 2015 Aidan Feldman
 * Licensed under MIT (https://github.com/afeld/bootstrap-toc/blob/gh-pages/LICENSE.md) */
function bootstrapTOC($) {
    "use strict";
    window.Toc = {
        helpers: {
            // return all matching elements in the set, or their descendants
            findOrFilter: function ($el, selector) {
                // http://danielnouri.org/notes/2011/03/14/a-jquery-find-that-also-finds-the-root-element/
                // http://stackoverflow.com/a/12731439/358804
                var $descendants = $el.find(selector);
                return $el
                    .filter(selector)
                    .add($descendants)
                    .filter(":not([data-toc-skip])");
            },
            generateUniqueIdBase: function (el) {
                var text = $(el).text();
                // adapted from
                // https://github.com/bryanbraun/anchorjs/blob/65fede08d0e4a705f72f1e7e6284f643d5ad3cf3/anchor.js#L237-L257
                // Regex for finding the non-safe URL characters (many need escaping): & +$,:;=?@"#{}|^~[`%!'<>]./()*\ (newlines, tabs, backspace, & vertical tabs)
                var nonsafeChars = /[& +$,:;=?@"#{}|^~[`%!'<>\]\.\/\(\)\*\\\n\t\b\v]/g, urlText;
                // Note: we trim hyphens after truncating because truncating can cause dangling hyphens.
                // Example string:                      // " ⚡⚡ Don't forget: URL fragments should be i18n-friendly, hyphenated, short, and clean."
                urlText = text
                    .trim() // "⚡⚡ Don't forget: URL fragments should be i18n-friendly, hyphenated, short, and clean."
                    .replace(/\'/gi, "") // "⚡⚡ Dont forget: URL fragments should be i18n-friendly, hyphenated, short, and clean."
                    .replace(nonsafeChars, "-") // "⚡⚡-Dont-forget--URL-fragments-should-be-i18n-friendly--hyphenated--short--and-clean-"
                    .replace(/-{2,}/g, "-") // "⚡⚡-Dont-forget-URL-fragments-should-be-i18n-friendly-hyphenated-short-and-clean-"
                    .substring(0, 64) // "⚡⚡-Dont-forget-URL-fragments-should-be-i18n-friendly-hyphenated-"
                    .replace(/^-+|-+$/gm, "") // "⚡⚡-Dont-forget-URL-fragments-should-be-i18n-friendly-hyphenated"
                    .toLowerCase(); // "⚡⚡-dont-forget-url-fragments-should-be-i18n-friendly-hyphenated"
                return urlText || el.tagName.toLowerCase();
            },
            generateUniqueId: function (el) {
                var anchorBase = this.generateUniqueIdBase(el);
                for (var i = 0;; i++) {
                    var anchor = anchorBase;
                    if (i > 0) {
                        // add suffix
                        anchor += "-" + i;
                    }
                    // check if ID already exists
                    if (!document.getElementById(anchor)) {
                        return anchor;
                    }
                }
            },
            generateAnchor: function (el) {
                if (el.id) {
                    return el.id;
                }
                else {
                    var anchor = this.generateUniqueId(el);
                    el.id = anchor;
                    return anchor;
                }
            },
            createNavList: function () {
                return $('<ul class="nav navbar-nav"></ul>');
            },
            createChildNavList: function ($parent) {
                var $childList = this.createNavList();
                $parent.append($childList);
                return $childList;
            },
            generateNavEl: function (anchor, text) {
                var $a = $('<a class="nav-link"></a>');
                $a.attr("href", "#" + anchor);
                $a.text(text);
                var $li = $("<li></li>");
                $li.append($a);
                return $li;
            },
            generateNavItem: function (headingEl) {
                var anchor = this.generateAnchor(headingEl);
                var $heading = $(headingEl);
                var text = $heading.data("toc-text") || $heading.text();
                return this.generateNavEl(anchor, text);
            },
            // Find the first heading level (`<h1>`, then `<h2>`, etc.) that has more than one element. Defaults to 1 (for `<h1>`).
            getTopLevel: function ($scope) {
                for (var i = 1; i <= 6; i++) {
                    var $headings = this.findOrFilter($scope, "h" + i);
                    if ($headings.length > 1) {
                        return i;
                    }
                }
                return 1;
            },
            // returns the elements for the top level, and the next below it
            getHeadings: function ($scope, topLevel) {
                var topSelector = "h" + topLevel;
                var secondaryLevel = topLevel + 1;
                var secondarySelector = "h" + secondaryLevel;
                return this.findOrFilter($scope, topSelector + "," + secondarySelector);
            },
            getNavLevel: function (el) {
                return parseInt(el.tagName.charAt(1), 10);
            },
            populateNav: function ($topContext, topLevel, $headings) {
                var $context = $topContext;
                var $prevNav;
                var helpers = this;
                $headings.each(function (i, el) {
                    var $newNav = helpers.generateNavItem(el);
                    var navLevel = helpers.getNavLevel(el);
                    // determine the proper $context
                    if (navLevel === topLevel) {
                        // use top level
                        $context = $topContext;
                    }
                    else if ($prevNav && $context === $topContext) {
                        // create a new level of the tree and switch to it
                        $context = helpers.createChildNavList($prevNav);
                    } // else use the current $context
                    $context.append($newNav);
                    $prevNav = $newNav;
                });
            },
            parseOps: function (arg) {
                var opts;
                if (arg.jquery) {
                    opts = {
                        $nav: arg
                    };
                }
                else {
                    opts = arg;
                }
                opts.$scope = opts.$scope || $(document.body);
                return opts;
            }
        },
        // accepts a jQuery object, or an options object
        init: function (opts) {
            opts = this.helpers.parseOps(opts);
            // ensure that the data attribute is in place for styling
            opts.$nav.attr("data-toggle", "toc");
            var $topContext = this.helpers.createChildNavList(opts.$nav);
            var topLevel = this.helpers.getTopLevel(opts.$scope);
            var $headings = this.helpers.getHeadings(opts.$scope, topLevel);
            this.helpers.populateNav($topContext, topLevel, $headings);
        }
    };
    $(function () {
        $('nav[data-toggle="toc"]').each(function (i, el) {
            var $nav = $(el);
            Toc.init($nav);
        });
    });
}
//# sourceMappingURL=bootstrap-toc.js.map
},{}],2:[function(require,module,exports){
"use strict";
//This code is run when a page is loaded by the user
//1. look for references to akit exercises (tag: akit-tutorial-exercise instances)
//2. collect the exercise-ids
//3. create sessions
//4. replace with proper akit-exercise or akit-interaction instances
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AKIT_Exercise = void 0;
var akit_util_1 = require("./akit-util");
var AKIT_SCRIPT_SRC = 'https://widgets.algebrakit.com/akit-widgets.min.js';
var AKIT_TESTBENCH_URL = 'https://testbench.algebrakit.com/editor/';
var AKIT_CONFIG = {
    config: {
        styles: {
            general: {
                'border-radius': '10px'
            },
            multistep: {
                'color-worksheet-bg': 'white',
                'border-worksheet': '1px solid #ccc',
                'color-buttons-bg': 'white',
                'color-buttons-bg-hover': '#ccc',
            },
        }
    }
};
var AKIT_Exercise = /** @class */ (function () {
    function AKIT_Exercise() {
        this.exercises = [];
    }
    AKIT_Exercise.prototype.convert = function () {
        return __awaiter(this, void 0, void 0, function () {
            var scriptPromise, getSessionsPromise, _resolveArr, getSessionsResponse, ii, resp, sessionMap;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this._getExercises();
                        if (this.exercises.length == 0)
                            return [2 /*return*/];
                        scriptPromise = this.addAkitScriptTagIfNeccessary();
                        getSessionsPromise = this._getSessions();
                        return [4 /*yield*/, Promise.all([getSessionsPromise, scriptPromise])];
                    case 1:
                        _resolveArr = _a.sent();
                        if (!_resolveArr || _resolveArr.length != 2)
                            return [2 /*return*/];
                        getSessionsResponse = _resolveArr[0];
                        for (ii = 0; ii < this.exercises.length; ii++) {
                            resp = getSessionsResponse[ii];
                            if (resp.success) {
                                resp = resp.sessions[0];
                                if (resp.success) {
                                    sessionMap = {};
                                    this.exercises[ii].sessionMap = sessionMap;
                                    this.exercises[ii].current = 0;
                                    sessionMap[this.exercises[ii].ids[0]] = {
                                        sessionId: resp.sessionId,
                                        html: resp.html,
                                        marksTotal: resp.marksTotal
                                    };
                                }
                                this.addExerciseTag(this.exercises[ii]);
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    AKIT_Exercise.prototype.replay = function (exObj) {
        return __awaiter(this, void 0, void 0, function () {
            var id, resp, _s;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        exObj.dom.innerHTML = '';
                        id = exObj.ids[exObj.current];
                        return [4 /*yield*/, (0, akit_util_1.createSessions)([id])];
                    case 1:
                        resp = _a.sent();
                        if (resp && resp.length == 1 && resp[0].success) {
                            _s = resp[0].sessions[0];
                            exObj.sessionMap[id] = {
                                sessionId: _s.sessionId,
                                html: _s.html,
                                marksTotal: _s.marksTotal
                            };
                        }
                        this.addExerciseTag(exObj);
                        return [2 /*return*/];
                }
            });
        });
    };
    AKIT_Exercise.prototype.solution = function (exObj) {
        exObj.dom.innerHTML = '';
        this.addExerciseTag(exObj, { solution: true });
    };
    AKIT_Exercise.prototype.selectExercise = function (exId, exObj) {
        return __awaiter(this, void 0, void 0, function () {
            var index, exerciseId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        index = exObj.ids.findIndex(function (_id) { return _id == exId; });
                        exObj.current = index;
                        exerciseId = exObj.ids[exObj.current];
                        exObj.dom.innerHTML = '';
                        if (!!exObj.sessionMap[exerciseId]) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.replay(exObj)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        this.addExerciseTag(exObj);
                        return [2 /*return*/];
                }
            });
        });
    };
    AKIT_Exercise.prototype._getSessions = function () {
        var ids = this.exercises.map(function (_ex) { return _ex.ids[0]; });
        return (0, akit_util_1.createSessions)(ids);
    };
    AKIT_Exercise.prototype._getExercises = function () {
        var elms = document.body.querySelectorAll('akit-tutorial-exercise');
        if (!elms)
            return;
        for (var ii = 0; ii < elms.length; ii++) {
            this.exercises.push(__assign(__assign({}, JSON.parse(elms[ii].textContent)), { dom: elms[ii] }));
        }
    };
    AKIT_Exercise.prototype.addAkitScriptTagIfNeccessary = function () {
        if (window.AlgebraKIT && window.AlgebraKIT._api)
            return Promise.resolve();
        window.AlgebraKIT = AKIT_CONFIG;
        (0, akit_util_1._addScriptTag)(AKIT_SCRIPT_SRC);
    };
    AKIT_Exercise.prototype.addExerciseTag = function (exObj, options) {
        var _this = this;
        var exClass = '';
        if (!options)
            options = {};
        var solutionMode = options.solution;
        var tag;
        var exerciseId = exObj.ids[exObj.current];
        var buttons = '';
        if (exObj.allowEdit) {
            buttons += "<button><i class=\"demo-icon icon-edit\"></i><a href=\"".concat(AKIT_TESTBENCH_URL + exerciseId, "\" target=\"_blank\">Edit</a></button>");
        }
        if (exObj.allowSolution && !solutionMode) {
            buttons += "<button class=\"akit-solution-button\"><i class=\"demo-icon icon-menu-outline\"></i>Solution</button>";
        }
        if (exObj.allowReplay) {
            buttons += "<button class=\"akit-replay-button\"><i class=\"demo-icon icon-cw\"></i>Repeat</button>";
        }
        if (exObj.border) {
            exClass = 'border';
        }
        if (exObj.refIds) {
            tag = "<akit-interaction session-id=\"".concat(exObj.sessionMap[exerciseId].sessionId, "\" ref-id=\"").concat(exObj.refIds[exObj.current], "\" class=\"").concat(exClass, "\"></akit-interaction>");
        }
        else if (solutionMode) {
            tag = "<akit-exercise session-id=\"".concat(exObj.sessionMap[exerciseId].sessionId, "\"  class=\"").concat(exClass, "\" solution-mode></akit-exercise>");
        }
        else {
            tag = exObj.sessionMap[exerciseId].html;
        }
        var selectorTag = '';
        if (exObj.names) {
            var options_1 = exObj.names
                .map(function (_name, _ind) {
                return _ind == exObj.current
                    ? "<option value=\"".concat(exObj.ids[_ind], "\" selected>").concat(_name, "</option>")
                    : "<option value=\"".concat(exObj.ids[_ind], "\">").concat(_name, "</option>");
            })
                .join('\n');
            selectorTag = "<select class=\"form-select\">".concat(options_1, "</select>");
        }
        var html = "<div class=\"akit-exercise-wrapper\">\n            <div class=\"akit-ex-label\">LIVE</div>\n            $AKIT_EX\n            <div class='akit-ex-footer'>\n                $EX_SELECTOR\n                <div class='akit-button-wrapper'>\n                $AKIT_BUTTONS\n                </div>\n            </div>\n        </div>";
        exObj.dom.innerHTML = html
            .replace("$AKIT_EX", tag)
            .replace("$EX_SELECTOR", selectorTag)
            .replace("$AKIT_BUTTONS", buttons);
        var solutionButtonObj = exObj.dom.querySelector('button.akit-solution-button');
        if (solutionButtonObj)
            solutionButtonObj.addEventListener('click', function () { return _this.solution(exObj); });
        var repeatButtonObj = exObj.dom.querySelector('button.akit-replay-button');
        if (repeatButtonObj)
            repeatButtonObj.addEventListener('click', function () { return _this.replay(exObj); });
        var selectObj = exObj.dom.querySelector('select.form-select');
        if (selectObj) {
            selectObj.addEventListener('change', function (evt) { return _this.selectExercise(evt.target.value, exObj); });
        }
        if (exObj.border) {
            var _elm = exObj.dom.querySelector('.akit-exercise-wrapper > akit-exercise');
            if (!_elm)
                _elm = exObj.dom.querySelector('.akit-exercise-wrapper > akit-interaction');
            if (_elm)
                _elm.classList.add('border');
        }
        exObj.dom.querySelector('.akit-ex-label').style.top = "" + (-15 + exObj.labelOffset) + 'px';
    };
    return AKIT_Exercise;
}());
exports.AKIT_Exercise = AKIT_Exercise;
//# sourceMappingURL=akit-exercise.js.map
},{"./akit-util":3}],3:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSessions = createSessions;
exports.post = post;
exports._addScriptTag = _addScriptTag;
var AKIT_SERVICE_BASE = 'https://testbench.algebrakit.com/algebrakit-secure';
var AKIT_CREATE_SESSIONS_URL = AKIT_SERVICE_BASE + '/session/create';
function createSessions(ids) {
    var req = {
        exercises: ids.map(function (_id) {
            return {
                exerciseId: _id,
                version: 'latest'
            };
        }),
        'api-version': 2,
        attributes: {}
    };
    return post(AKIT_CREATE_SESSIONS_URL, req);
}
/**
* Perform Post
* @param {string} url
* @param {any} data
* @returns a promise with the response if succesful. If not succesful, rejects with an error message (string)
*/
function post(url, data) {
    return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.open('POST', url, true);
        xhr.onload = function () {
            if (xhr.status === 200) { // This is called even on 404 etc, so check the status
                var contentType = xhr.getResponseHeader('content-type');
                if (contentType && contentType.search('application/json') >= 0) {
                    var result = {};
                    if (xhr.responseText.length > 0) {
                        result = eval('(' + xhr.responseText + ')');
                    }
                    resolve(result);
                }
                else {
                    reject(Error('Invalid response from akit proxy'));
                }
            }
            else {
                if (xhr.response) {
                    reject(Error(xhr.response));
                }
                reject(Error(xhr.statusText));
            }
        };
        // Handle network errors
        xhr.onerror = function (args) {
            reject(Error("Network Error"));
        };
        // Make the request
        var isBinary = (data.constructor === FormData);
        if (isBinary) {
            xhr.overrideMimeType("text/plain; charset=x-user-defined");
            xhr.responseType = "arraybuffer"; //xhr 2
        }
        else if (typeof (data) === 'string') {
            xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
        }
        else {
            xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
            data = JSON.stringify(data);
        }
        xhr.send(data);
    });
}
function _addScriptTag(src) {
    return new Promise(function (resolve, reject) {
        var s = document.createElement('script');
        var r = false;
        s.type = 'text/javascript';
        s.src = src;
        s.async = true;
        s.onerror = function (err) {
            reject(err);
        };
        s.onload = s.onreadystatechange = function () {
            // console.log(this.readyState); // uncomment this line to see which ready states are called.
            if (!r && (!this.readyState || this.readyState == 'complete')) {
                r = true;
                resolve(null);
            }
        };
        document.body.append(s);
    });
}
//# sourceMappingURL=akit-util.js.map
},{}],4:[function(require,module,exports){
"use strict";
//This code is run when a page is loaded by the user
//1. look for references to akit exercises (tag: akit-tutorial-exercise instances)
//2. collect the exercise-ids
//3. create sessions
//4. replace with proper akit-exercise or akit-interaction instances
Object.defineProperty(exports, "__esModule", { value: true });
var akit_exercise_1 = require("./akit-exercise");
var bootstrap_toc_js_1 = require("../../external/bootstrap-toc/bootstrap-toc.js");
(0, bootstrap_toc_js_1.bootstrapTOC)(jQuery);
// hide draft sections when deployed
if (window.location.host.indexOf('localhost') >= 0) {
    var wrapper = document.getElementById('main-content');
    wrapper.classList.add('dev-mode');
}
var AK = new akit_exercise_1.AKIT_Exercise();
AK.convert();
//# sourceMappingURL=main.js.map
},{"../../external/bootstrap-toc/bootstrap-toc.js":1,"./akit-exercise":2}]},{},[4])